import React from 'react';

import TypeFeedHighlight from 'scenes/FeedPost/components/FeedPostContent/components/TypeFeedHighlight';
import TypeCandidateMood from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateMood';
import TypeNewConnection from 'scenes/FeedPost/components/FeedPostContent/components/TypeNewConnection';
import TypeCandidateProfileUpdate from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateProfileUpdate';
import TypeCandidateRecommendation from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateRecommendation';
import TypeCandidatePositionApproved from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidatePositionApproved';
import TypeCandidateAddedReference from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateAddedReference';
import TypeProcess from 'scenes/FeedPost/components/FeedPostContent/components/TypeProcess';
import TypeCandidateApplication from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateApplication';
import TypeCandidateJoined from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateJoined';
import TypeCandidateMtest from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateMtest';
import TypeNewsItem from 'scenes/FeedPost/components/FeedPostContent/components/TypeNewsItem';
import TypeCandidateProfileUpgrade from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidateProfileUpgrade';
import TypeCandidatePosition from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidatePosition';
import TypeFirmRating from 'scenes/FeedPost/components/FeedPostContent/components/TypeFirmRating';
import TypeFirmReview from 'scenes/FeedPost/components/FeedPostContent/components/TypeFirmReview';
import TypeFirmReviewRating from 'scenes/FeedPost/components/FeedPostContent/components/TypeFirmReviewRating';
import TypeCandidatePurchasesInbounds from 'scenes/FeedPost/components/FeedPostContent/components/TypeCandidatePurchasesInbounds';
import TypeFirmPortfolioMark from 'scenes/FeedPost/components/FeedPostContent/components/TypeFirmPortfolioMark';

export const getPost = (post, actions, { options, user }) => {
  switch (Number(post.TypeID)) {
    case 0:
      return <TypeFeedHighlight post={post} actions={actions} />;
    // candidate_mood
    case 1:
      return (
        <TypeCandidateMood
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // connection
    case 2:
      return (
        <TypeNewConnection
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // candidate
    case 4:
      return (
        <TypeCandidateProfileUpdate
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // purchases inbounds
    case 5:
      return (
        <TypeCandidatePurchasesInbounds
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // recommendation
    case 6:
      return (
        <TypeCandidateRecommendation
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // candidate_position
    case 7:
      return (
        <TypeCandidatePositionApproved
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // candidate_reference
    case 8:
      return (
        <TypeCandidateAddedReference
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_rating
    case 9:
      return (
        <TypeFirmRating
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_interview
    case 10:
      return (
        <TypeFirmReview
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_review
    case 11:
      return (
        <TypeFirmReview
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // process
    case 16:
      return (
        <TypeProcess
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // application_process
    case 18:
      return (
        <TypeCandidateApplication
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // candidate
    case 19:
      return (
        <TypeCandidateJoined
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_review_rating
    case 20:
      return (
        <TypeFirmReviewRating
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_interview_rating
    case 21:
      return (
        <TypeFirmReviewRating
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // mtest_candidate
    case 22:
      return (
        <TypeCandidateMtest
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // news_rss_feed
    case 23:
      return (
        <TypeNewsItem
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // Candidate Profile Upgrade
    case 24:
      return (
        <TypeCandidateProfileUpgrade
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // candidate_position
    case 25:
      return (
        <TypeCandidatePosition
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_overview
    case 26:
      return (
        <TypeFirmReview
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_overview_rating
    case 27:
      return (
        <TypeFirmReviewRating
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    // firm_portfolio_mark
    case 28:
      return (
        <TypeFirmPortfolioMark
          user={user}
          post={post}
          actions={actions}
          options={options}
        />
      );
    default:
      return null;
  }
};
